"use client";
import React from "react";
import styles from "./home.module.css";
import { useTranslations } from "next-intl";

export default function HowItWorksSection() {
  const t = useTranslations("home");
  const steps = [
    { number: "1", titleKey: "step1Title", descKey: "step1Description" },
    { number: "2", titleKey: "step2Title", descKey: "step2Description" },
    { number: "3", titleKey: "step3Title", descKey: "step3Description" },
  ];
  return (
    <section className={styles.howItWorksSection}>
      <div className="container-md">
        <h2 className={styles.sectionTitle}>{t("howItWorksTitle")}</h2>
        <p className={styles.sectionDescription}>
          {t("howItWorksDescription")}
        </p>
        <div className={styles.stepsContainer}>
          {steps.map((step, index) => (
            <div key={index} className={styles.stepCard}>
              <div className={styles.stepNumber}>{step.number}</div>
              <h3 className={styles.stepTitle}>{t(step.titleKey)}</h3>
              <p className={styles.stepDescription}>{t(step.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
